export const SITEBANNER_QUERY = `
  query SiteBannerQuery($datasource: String!, $language: String!) {
    container: item(path: $datasource, language: $language) {
      id
      carousel: field(name: "carousel") {
        ... on MultilistField {
          banners: targetItems {
            desktopTitle: field(name: "desktopTitle") {
              value
            }
            mobileTitle: field(name: "mobileTitle") {
              value
            }
            desktopText: field(name: "desktopText") { 
              value
            } 
            mobileText: field(name: "mobileText") {
              value
            }
            desktopSubtitle: field(name: "desktopSubtitle") { 
              value
            }
            mobileSubtitle: field(name: "mobileSubtitle") { 
              value
            }
            code: field(name: "code") { 
              value
            }
            theme: field(name: "theme") {
              value
            }
            ctaRef: field(name: "ctaRef") {
              value
            }
            ctaUrl: field(name: "ctaUrl") {
              ... on LinkField {
                id
                href: url
                linkType
                target
                text
                anchor
              }
            }
          }
        }
      }
    }
  }
`;
